function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#00148C"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "20 2.83037217 20 3.41962783 17.870453 5.54917479 18.1650809 5.84380261 4.00888348 20 2.24111652 20 17.2811974 4.95991913 17.5758252 5.25454696"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "18.2470388 7.10542736e-15 18.8362945 7.10542736e-15 9.95378637 8.88250812 10.2484142 9.17713594 8.17124146e-14 19.4255501 8.17124146e-14 17.6577832 9.36453072 8.29325247 9.65915855 8.58788029"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "20 7.41370551 20 8.00296116 12.870453 15.1325081 13.1650809 15.4271359 8.59221681 20 6.82444986 20 12.2811974 14.5432525 12.5758252 14.8378803"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "13.6637055 0 14.2529612 0 4.53711971 9.71584145 4.83174753 10.0104693 8.17124146e-14 14.8422168 8.24525633e-14 13.0744499 3.94786406 9.1265858 4.24249188 9.42121363"
})));

var SvgGridLines = function SvgGridLines(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    className: "icon icon-grid-lines",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGridLines, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grid-lines.9017bf21.svg";
export { ForwardRef as ReactComponent };